// extracted by mini-css-extract-plugin
export default {"thumbprint":"uWz2bcuiCva5IgQigiuQ"};